import React, { useEffect, useState } from "react";
import Select from "react-select";
import { createFilter } from "react-select";

import SeoHelmet from "../../Seo/SeoHelmet";
import axios from "axios";
import PropTypes from "prop-types";

import { useLocation } from "react-router-dom";
function SearchBarv2({ onSimilarResults,t }) {

  const location = useLocation();
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [currentSuggestions, setCurrentSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [selectedType, setSelectedType] = useState({ value: "all", label: t("General Search") });

  const [isFetching, setIsFetching] = useState(false);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchTerm = searchParams.get("search");
  
    if (searchTerm) {
      setInputValue(searchTerm);
      setSelectedType({  value: "all", label: "General Search" });
  
      // ✅ Ensure search triggers only when a valid search term exists
      setTimeout(() => handleTriggerSearchResult(searchTerm), 100);
    }
  }, [location.search]);


  useEffect(() => {
    setSelectedType((prev) => ({
      ...prev,
      label: t(prev.value === "single-card" ? "Single Card" : "General Search"),
    }));
  }, [t]);


  useEffect(() => {
    console.log('searchSuggestions',searchSuggestions)
    if (searchSuggestions.length > 0 && searchSuggestions !== currentSuggestions) {
      console.log('searchSuggestions2',searchSuggestions)
      setCurrentSuggestions(searchSuggestions);
    } else {
      setCurrentSuggestions([]);
    }
  }, [searchSuggestions]);

  const fetchSuggestions2 = async (inputValue) => {
    setIsFetching(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch?searchTerm=${inputValue}`);
      return mapResponseToOptions(response.data) || [];
    } catch (error) {
      console.error("Error fetching deep search suggestions:", error);
      return [];
    } finally {
      setIsFetching(false);
    }
  };

  const mapResponseToOptions = (data) => {
    return data.map((item) => {
          return {
            value: item.CardId,
            label: item.SearchTitle,
            Image: item.Image,
          };
      })
    };
  

  const fetchResult2 = async (inputValue) => {
    setIsFetching(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/SearchBar?searchTerm=${inputValue}`);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching general search results:", error);
      return [];
    } finally {
      setIsFetching(false);
    }
  };

  const handleTypeChange = (selectedOption) => {
    console.log('selectedOption',selectedOption)
    setSelectedType(selectedOption);
    setCurrentSuggestions([]);
    setInputValue("");
  };

  const handleInputChange = (value) => {
    setInputValue(value);
    if (selectedType.value === "single-card" && value.length >= 3) {
      fetchSuggestions2(value).then(setSearchSuggestions);

    }
  };

  // const handleInputChange2 = (inputValue,validSearch) => {
  //   setInputValue(inputValue);
  //   // Split the input value into words using spaces as separators
  //   // Check if the last word is at least 3 characters long
  //   if (inputValue.length >= 4 && validSearch!=false) {
  //     // Split the input value into words using spaces as separators
  //     const words = inputValue.split(" ");
  //     // Get the last word entered by the user
  //     const lastWord = words[words.length - 1];

  //     if (lastWord.length >= 3) {
  //       clearTimeout(fetchTimeout);

  //       // Set a new timeout to fetch suggestions after a short delay
  //       fetchTimeout = setTimeout(() => {
  //         fetchSuggestions2(inputValue)
  //           .then((suggestions) => {
  //             setSearchSuggestions(suggestions);
  //           })
  //           .catch((error) => {
  //             console.error("Error handling input change:", error);
  //             setSearchSuggestions([]);
  //           });
  //       }, 300); // Adjust the delay (in milliseconds) as needed
  //     } else {
  //       // Clear suggestions if the input is less than 3 characters
  //       setSearchSuggestions([]);
  //       setIsSuggestionOpen(false);
  //     }
  //   }
  //   else{
  //     setCurrentSuggestions([]);
  //       setIsSuggestionOpen(false);
  //   }
  // };

  const handleTriggerSearchResult = async (searchTerm) => {
    // Ensure the query is valid and not an event object
    const query = typeof searchTerm === "string" ? searchTerm : inputValue;
  
    console.log("query avant plante:", query, "Type:", typeof query);
  
    if (!query || query.trim() === "") {
      console.warn("❌ No search term provided. Skipping search.");
      return;
    }
  
    let results;
    if (selectedType.value === "single-card") {
      results = await fetchSuggestions2(query);
    } else {
      results = await fetchResult2(query);
    }
  
    onSimilarResults(results);
  };
  
  const handleSearch = async (selectedOption) => {
    if (!selectedOption) return;
    try {
      let response;
      if (selectedType.value === "single-card") {
        response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch/GetSellingsCards?searchTerm=${selectedOption.label}`);
      } else {
        response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/SearchBar?searchTerm=${selectedOption.label}`);
      }
      onSimilarResults(response.data);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      border: "1px solid #444",
      color: "white",
      borderRadius: "8px",
      padding: "6px",
      "&:hover": { borderColor: "#0066FFED" },
      minWidth:'30vw',
      minHeight: '55px'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#181818",
      borderRadius: "6px",
      padding: "5px",
      border: "1px solid #444",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "#F5F5F5",
      backgroundColor: state.isSelected ? "#0066FFED" : "#222",
      padding: "10px",
      borderRadius: "6px",
      "&:hover": { backgroundColor: "#0066FFED", color: "white" },
    }),
  };
  const customSelectStylesSmaller = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      border: "1px solid #444",
      color: "white",
      borderRadius: "8px",
      padding: "6px",
      "&:hover": { borderColor: "#0066FFED" },
      //width: "30%", // Adjusted width for the type selection
      minWidth: "15vw",
      
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#181818",
      borderRadius: "6px",
      padding: "5px",
      border: "1px solid #444",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "#F5F5F5",
      backgroundColor: state.isSelected ? "#0066FFED" : "#222",
      padding: "10px",
      borderRadius: "6px",
      "&:hover": { backgroundColor: "#0066FFED", color: "white" },
    }),
  };

  
  function ApplyPatch(label) {
    // Split the label by " - ", but preserve years like 2018-19
    const parts = label.split(" - ").filter((part) => !/^\d{4}-\d{2}$/.test(part));
    // Ensure at least 4 parts before taking patches
    if (parts.length > 4) {
      const patches = parts.slice(4);      
      return (
        <div className="card-isfor">
          {patches.map((patch, index) => (
            <div key={index} className="Searchpatch">
              {patch}
            </div>
          ))}
        </div>
      );
    }
    return null; // Return null if there are no patches to display
  }
// Inside your component
const customFilterOption = createFilter({
  ignoreCase: true,
  ignoreAccents: true,
  matchFrom: 'any', // This is key! Allows matching from anywhere, not just start
  stringify: (option) => option.label // optional if default stringify is fine
});


  return (
    <div className="searchBarSection">
      {/* Search Type Dropdown */}
       <SeoHelmet type="search" />
      <div className="search-group">
<Select
  styles={customSelectStylesSmaller}
  className="search-select-small"
  placeholder={t("Select a search type")}
  options={[
    { value: "single-card", label: t("Single Card") },
    { value: "all", label: t("General Search") },
  ]}
  value={selectedType}  // ✅ Automatically updates when `t()` changes
  onChange={handleTypeChange}
  isSearchable={false}
  isClearable={false}
/>

      

      {/* Conditionally Render Search Input */}
     
        {selectedType.value === "single-card" ? (
          <Select
            className="search-select"
            
            styles={customSelectStyles}
            
            isClearable
            onChange={handleSearch}
            onInputChange={(value) => handleInputChange(value)}
            options={currentSuggestions}
            value={currentSuggestions}
            menuIsOpen={currentSuggestions.length > 0}
            onMenuClose={() => setCurrentSuggestions([])} 
            filterOption={customFilterOption}
            formatOptionLabel={(currentSuggestion) => {
              // Extract label without patches
              const fullLabel = currentSuggestion.label||"";
              const parts = fullLabel.split(" - ").filter((part) => !/^\d{4}-\d{2}$/.test(part));
              const cleanLabel = parts.slice(0, 4).join(" - "); // Keep first 4 parts as main title
            
              return (
                <div className="suggestion-item">
                  {currentSuggestion.Image ? (
                    <img src={`https://corsproxy.io/?${encodeURIComponent(currentSuggestion.Image)}`} alt="currentSuggestion-image"
                    />
                  ) : null}
                  <div className="text-content">
                    <span className="card-title">{cleanLabel}</span>
                    <div className="card-details">{ApplyPatch(fullLabel)}</div>
                  </div>
                
                </div>
              );
            }}
          />
        ) : (
          <input
            type="text"
            //style={customSelectStyles}
            className="search-input"
           
            value={inputValue}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleTriggerSearchResult()}
          />
        )}
        <button className="search-button" onClick={()=>handleTriggerSearchResult()}>
          {t('Search')}
        </button>
      </div>

      {/* Conditional Suggestions Dropdown */}
 
    </div>
  );
}

export default SearchBarv2;
